module.exports = __webpack_public_path__ + "be3de788e24fadb22a3f3d4a231ff259.svg";